import { Controller } from "stimulus"
import axios from 'axios';

export default class extends Controller {
  static get targets() {
    return [ "selection", "totals" ];
  }

  initialize(){
  }

  changeSelection(event){
    this.selectionTargets.forEach((el,i) => {
        let theRow = el.parentElement.parentElement;
        theRow.classList.toggle("shippingtable__selected_row", el == event.target );
    });

    
    let token = document.getElementsByName('csrf-token')[0].getAttribute('content')
    axios.defaults.headers.common['X-CSRF-Token'] = token


    let totalsElement = document.getElementById("totalsbox__container");
    totalsElement.innerHTML = document.getElementById("spinner__container").innerHTML;

    const options = {
      method: 'PUT',
      headers: { 'Accept': 'text/html' },
      data: {shipping_service: event.target.value},
      url: this.data.get("target") 
    };
    axios(options)
        .then(function(response){
          totalsElement.innerHTML = response.data;
        }).catch(function(err){
           // t.errorsTarget.innerHTML = err.response.data.errors;
           // t.errorsTarget.style.display = "block";
        });
  }

}



// WEBPACK FOOTER //
// ./app/javascript/store_front/controllers/select_shipping_controller.js